var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ERentioFormField } from "../../components/components/Form";
import { getValue } from "../../redux/form/form.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { EField } from "./schema.signIn.types";
import { getSignInCaptchaSchema } from "./schema.signIn.utils";
export var getSchema = function (initialValues) {
    return function (defaultValues) {
        var _a;
        var captcha = getSignInCaptchaSchema(initialValues, defaultValues);
        return {
            required: __spreadArray([EField.PhoneOrEmail, EField.Password], captcha.required, true),
            properties: __assign((_a = {}, _a[EField.PhoneOrEmail] = {
                default: getValue(EField.PhoneOrEmail, initialValues, defaultValues),
            }, _a[EField.Password] = {
                default: getValue(EField.Password, initialValues, defaultValues),
                minLength: 8,
            }, _a), captcha.properties),
        };
    };
};
export var uiSchema = function () {
    var _a;
    return (__assign((_a = { "rentio:trackingKey": "sign-in" }, _a[EField.PhoneOrEmail] = {
        "ui:field": ERentioFormField.PhoneOrEmail,
        title: getLocalizedText("auth.phone_or_email.label"),
        placeholder: getLocalizedText("auth.phone_or_email.label"),
    }, _a[EField.Password] = {
        "ui:field": ERentioFormField.Text,
        title: getLocalizedText("system.password"),
        placeholder: getLocalizedText("form.sign_in.password.placeholder"),
        secureTextEntry: true,
    }, _a), getSignInCaptchaSchema({}, {}).uiSchema));
};
